import React from "react";

const DateCell = ({ value }) => {
  return <span>{new Date(value).toLocaleDateString()}</span>;
};

export default DateCell;
